import { useEffect, useRef } from "react";

/**
 * We should use this when we are showing UI that are not bound by URL
 * state but which are like a screen.
 * It makes sense for the user to expect the back button to close the
 * drawer f.e.
 */
export const useBackButtonHijack = (isActive: boolean, onBack: () => void) => {
	const isActiveRef = useRef(isActive);
	const hasInitializedRef = useRef(false);
	isActiveRef.current = isActive;
	useEffect(() => {
		if (!isActiveRef.current) return;

		const handlePopState = (e: PopStateEvent) => {
			if (confirm("You have unsaved progress. Are you sure you want to go back?")) {
				onBack();
				return;
			}
			e.preventDefault();

			// Push a new state to prevent actually going back
			window.history.pushState(null, "", window.location.href);
		};

		// Push a state when opening to enable back button interception
		if (!hasInitializedRef.current) {
			window.history.pushState(null, "", window.location.href);
		}
		hasInitializedRef.current = true;
		window.addEventListener("popstate", handlePopState, { once: true });

		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, [onBack]);
};
